import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined
} from '@ant-design/icons';
import { useGet } from '@src/api/methods';
import { Button, Table } from 'antd';
import { useState } from 'react';
import './UsersTab.scss';
import NewCompanyModal from './UsersTab/NewCompanyModal';
import UpdateCompanyModal from './UsersTab/UpdateCompanyModal';

function CompaniesTab() {
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
  const [isNewCompanyModalVisible, setIsNewCompanyModalVisible] =
    useState(false);

  const { data, isPending } = useGet('/companies');
  console.log(data);

  const handleUpdateModalOpen = (record) => {
    setSelectedCompany(record);
    setIsUpdateModalVisible(true);
  };

  const handleUpdateModalClose = () => {
    setIsUpdateModalVisible(false);
  };

  const columns = [
    {
      title: 'İsim',
      key: 'name',
      render: (record) => `${record.name}`
    },
    { title: 'Üyelik Tarihi', dataIndex: 'createdAt', key: 'createdAt' },
    {
      title: 'Aktif',
      key: 'status',
      render: (record) => {
        return record.status === 'ACTIVE' ? (
          <div className="flex items-center ml-2">
            <CheckCircleOutlined className="text-green-500 text-lg" />
          </div>
        ) : (
          <div className="flex items-center ml-2">
            <CloseCircleOutlined className="text-red-500 text-lg" />
          </div>
        );
      }
    },
    {
      title: '',
      key: 'actions',
      render: (record) => {
        return (
          <div className="flex flex-row gap-2">
            <Button
              type="primary"
              icon={<EditOutlined />}
              onClick={() => handleUpdateModalOpen(record)}
              className="border-none rounded-md flex items-center justify-center w-8 h-8"
              title="Güncelle"
            />
          </div>
        );
      }
    }
  ];

  const handleNewCompanyModalVisible = () => {
    setIsNewCompanyModalVisible(false);
  };

  return (
    <div className="company-users-tab__">
      <div className="buttons-container">
        <Button
          style={{ width: 150, marginRight: '15px' }}
          className="kemi_form_btn_purple"
          onClick={() => setIsNewCompanyModalVisible(true)}
        >
          Yeni Firma Oluştur
        </Button>
      </div>
      <Table
        scroll={{ x: 1499 }}
        columns={columns}
        dataSource={data}
        loading={isPending}
        rowKey="id"
      />
      <NewCompanyModal
        key={'adminNewCompany'}
        handleModalVisible={handleNewCompanyModalVisible}
        isModalVisible={isNewCompanyModalVisible}
      />
      <UpdateCompanyModal
        key={'adminUpdateCompany'}
        handleModalVisible={handleUpdateModalClose}
        isModalVisible={isUpdateModalVisible}
        companyData={selectedCompany}
      />
    </div>
  );
}

export default CompaniesTab;
